<template>
  <div>
    <div class="page-header">
      <span class="h3">{{ $t("projects.parent") }} Archive</span>
      <router-link :to="$t('projects.parent_route')"><span class="h6 text-muted float-right">{{ $t("projects.parent") }}</span></router-link>
    </div>

    <ul class="mt-2 list-group">
      <draggable v-model="allArchivedProjects">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="project in allArchivedProjects" :key="project.id" class="list-group-item">
            <ProjectTitle :project=project />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
import api from "api";
import QuickTask from "components/QuickTask";
import ProjectTitle from "components/ProjectTitle";
import NewQuickTask from "components/NewQuickTask";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    ProjectTitle,
    Loading,
    draggable
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    allArchivedProjects: {
      get: function() {
        return this.$store.state.archived_projects
      }
    }
  }
};
</script>
